<ng-container *ngIf="useBlocks; else fallback">
  <ng-container *ngFor="let block of processedBlocks">

    <ng-container [ngSwitch]="block.type">

      <!-- Plain text segment -->
      <ng-container *ngSwitchCase="'text'">
        <ng-container *ngIf="isMathText(block.content || ''); else plainText">
          <app-math-latex [content]="block.content || ''">
          </app-math-latex>
        </ng-container>

        <ng-template #plainText>
          <span class="block-text">
            {{ block.content }}
          </span>
        </ng-template>
      </ng-container>

      <!-- LaTeX segment — delegate to existing math-latex renderer -->
      <app-math-latex
        *ngSwitchCase="'latex'"
        [content]="block.content || ''">
      </app-math-latex>

      <!-- Match-List / comparison table -->
      <div *ngSwitchCase="'table'" class="match-table-wrapper">
        <table class="match-table">
          <thead *ngIf="block.rows && block.rows.length > 0">
            <tr>
              <th *ngFor="let cell of $any(block.rows)[0]">{{ cell }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of $any(block.rows) | slice:1">
              <td *ngFor="let cell of $any(row)">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </ng-container>

  </ng-container>

  <ng-container *ngIf="diagrams?.length && !hasImageBlock">
    <img *ngFor="let diagram of diagrams" [src]="diagram.url || diagram.s3_key" [alt]="diagram.alt_text || 'diagram'"
      class="inline-diagram" />
  </ng-container>

</ng-container>

<!-- Fallback for existing questions that have no blocks field.
     MathLatexComponent handles [DIAGRAM_N] substitution via its diagrams input. -->
<ng-template #fallback>
  <app-math-latex
    [content]="content"
    [diagrams]="diagrams">
  </app-math-latex>
</ng-template>
